import useEndpointStore from "@/stores/useEndpointStore";
import { Danger } from "iconsax-react";
import { useMemo } from "react";
import { createRoot, type Root } from "react-dom/client";
import Button from "../Button/Button";
import LegacyModal from "../Modal/Modal";
import useCurrentLocale from "@/hooks/useCurrentLocale";

const EndpointModalComponent = () => {
  const locale = useCurrentLocale();

  const text = useMemo(() => {
    switch (locale) {
      case "zh-tw":
        return {
          content: "連接錯誤，請刷新",
          reload: "刷新",
        };
      case "vi-vn":
        return {
          content: "Lỗi kết nối, vui lòng làm mới.",
          reload: "làm cho khỏe lại",
        };
      case "th-th":
        return {
          content: "การเชื่อมต่อผิดพลาด กรุณารีเฟรช",
          reload: "รีเฟรช",
        };
      case "en-us":
        return {
          content: "Connection error, please refresh.",
          reload: "Refresh",
        };
      case "zh-cn":
      default:
        return {
          content: "连接错误，请刷新",
          reload: "刷新",
        };
    }
  }, [locale]);

  const reload = () => {
    useEndpointStore.setState({
      apiEndpoint: "",
    });

    window.location.reload();
  };

  return (
    <LegacyModal isOpen className="z-[9999]">
      <div className="flex-center flex flex-col gap-6">
        <div className="flex w-full items-center gap-2">
          <Danger size={40} className="text-red-400" color="currentColor" />

          <span>{text.content}</span>
        </div>

        <Button className="ml-auto" shape="gradient" color="primary" onClick={reload}>
          {text.reload}
        </Button>
      </div>
    </LegacyModal>
  );
};

type EndpointModal = {
  root: Root | null;
  rendered: boolean;
  open: () => void;
  close: () => void;
};

export const EndpointModal: EndpointModal = {
  root: null,
  rendered: false,
  open() {
    if (!this.root) {
      const container = document.createDocumentFragment();
      this.root = createRoot(container);
    }

    if (!this.rendered) {
      this.root.render(<EndpointModalComponent />);
      this.rendered = true;
    }
  },
  close() {
    this.root?.unmount();
    this.root = null;
    this.rendered = false;
  },
};

export default EndpointModal;
